import Api from "@/api/Api";
import { API_ROUTES, requestTokens } from "@/settings/apiRoutes";
import { AgencyListEntity } from "@/types/plans";

export interface AgenciesListResponse {
  data: AgencyListEntity[];
}

export default class AgenciesApi {
  async getAllAgencies(): Promise<AgenciesListResponse> {
    return await Api.request<AgenciesListResponse>({
      path: API_ROUTES.AGENCIES.PATH,
      method: "get",
      token: requestTokens.apiGetAgencies,
      defaultResult: {
        data: [],
      },
    });
  }
}
